/* Avvia i video delle sezioni home solo quando sono visibili e li sospende fuori viewport. */
(() => {
  const videos = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const media = entry.target;
      if (!entry.isIntersecting || entry.intersectionRatio < 0.2) {
        media.pause?.();
        return;
      }
      media.play?.().catch(() => {});
    });
  }, { rootMargin: '50% 0px', threshold: [0, 0.2] }) : null;

  function watch(root) {
    if (!root || root.dataset.extroViewportReady === 'true') return;
    root.dataset.extroViewportReady = 'true';
    videos.add(root);
    observer?.observe(root);
  }

  document.querySelectorAll('[data-extro-viewport-video], [data-extro-viewport-external-video]').forEach(watch);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll?.('[data-extro-viewport-video], [data-extro-viewport-external-video]').forEach(watch);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach(video => video.pause?.());
  });
})();
